<template>
  <div>
    <el-row>
      <el-col :span="24"
              style="height: 150px;display: flex;justify-content: space-between;align-items: center;padding: 20px">
        <div style="display: flex;justify-content: space-between">
          <el-avatar :size="100" :src="wechatData.headimgurl">
            <img src="../assets/alt_head.png"/>
          </el-avatar>
          <div style="display: flex;align-items: flex-start;padding-left: 20px;flex-direction: column;">
            <h4>{{ wechatData.nickname }}</h4>
            <div v-if="wechatData.unionId != ''" style="color: #B6B4C2;text-align:left;font-size:12px">{{ wechatData.unionId}}</div>
            <div v-else style="color: #B6B4C2;text-align:left;font-size:12px">{{ wechatData.openid || "*****" }}</div>
          </div>
        </div>
        <div v-if="wechatData.openid == '' && wechatData.unionId==''">
          <el-button type="primary" style="background-color: #6B50F6" @click="WechatAuthor" round>点击授权</el-button>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="height: 100px;display: flex;justify-content: space-around">
        <div class="baby-style">
          <div style="color: #C150F6;font-size: 16px;">{{ babyData.height || '**' }}厘米</div>
          <div style="color: #B6B4C2">长度</div>
        </div>
        <div class="baby-style">
          <div style="color: #C150F6;font-size: 16px;">{{ babyData.weight || '**' }}kg</div>
          <div style="color: #B6B4C2">重量</div>
        </div>
        <div class="baby-style">
          <div style="color: #C150F6;font-size: 16px;">{{ babyData.headCircumference || '**' }}cm</div>
          <div style="color: #B6B4C2">头围</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24" style="text-align: left;padding-left: 20px;margin-top: 20px"><b>我的工具</b></el-col>
    </el-row>
    <el-row>
      <el-col :span="24" class="baby-tool-style">
        <div
            @click="toBabyGrow"
            class="baby-tool-info-style">
          <div
              style="display: flex;flex-direction: column;align-items: flex-start;justify-content: space-around;height: 100%">
            <span style="font-size: 18px"><b>宝宝生长发育记录</b></span>
            <span style="color: #cfcdd9;font-size: 13px">对标生长曲线，科学评估发育</span>
            <el-button  style="color: #C150F6" round>立即使用</el-button>
          </div>
          <el-avatar :size="120">
            <img src="../assets/baby.png" alt=""/>
          </el-avatar>
        </div>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col :span="24" class="baby-tool-style">
        <div
            @click="toBabyFeed"
            class="baby-tool-info-style">
          <div
              style="display: flex;align-items: flex-start;flex-direction: column;justify-content: space-around;height: 100%">
            <span style="font-size: 18px"><b>宝宝喂养记录</b></span>
            <span style="color: #cfcdd9;font-size: 13px">喂养随心记，母乳奶粉兼可</span>
            <el-button style="color: #C150F6" round>立即使用</el-button>
          </div>
          <el-avatar :size="120">
            <img src="../assets/babymam.png" alt=""/>
          </el-avatar>
        </div>
      </el-col>
    </el-row>
    <div v-if="visibleConfirm"
         style="position: fixed;top: 0;height: 100%;background-color: #000000;width: 100%;opacity: 0.8;">
      <el-row style="position: absolute;bottom: 0;text-align: left;width: 100%;font-size: 21px;">
        <el-col :span="24" style="height: 50%;background-color: #f4ddfd;padding: 10px;border-radius: 20px;"><b>"星锚超级妈妈"申请获得以下权限：</b>
          <ul>
            <li>获得您的微信头像和昵称</li>
            <li>为您提供专属的宝宝成长记录</li>
          </ul>
          我们承诺您的信息仅用于为您提供记录服务。
          <div style="display: flex;justify-content: space-around;margin-top: 10px;">
            <el-button @click="visibleConfirm = false" style="color: #C150F6" round>关闭</el-button>
            <el-button @click="WechatAuthor" style="background-color:#C150F6;" type="primary" round>允许</el-button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import wx from "weixin-js-sdk"

export default {
  name: 'BabyTools',
  data() {
    return {
      visibleConfirm: false,
      wechatData: {
        openid: '',
        nickname: "******",
        sex: 1,
        province: "PROVINCE",
        city: "CITY",
        country: "COUNTRY",
        headimgurl: '',
        unionId: ''
      },
      babyData: {
        height: "**",
        weight: "**",
        headCircumference: "**"
      }
    }
  },
  created() {
    const expireTime = localStorage.getItem('expire_time');
    if (Date.now() > expireTime || expireTime == null) {
      localStorage.removeItem('wechat_user_info');
      // localStorage.removeItem('baby_user_info')
    }
    this.handleUrlParams()
    this.getLocalStorage()
    this.getBabyGrowth()
    this.initWechatConfig()
    console.log(this.wechatData)
  },
  methods: {
    onTool() {
      this.visibleConfirm = true
    },
    getBabyGrowth(){
      if (this.wechatData.openid != '') {
        axios.get("/prod-api/babyGrowthNote/getBabyGrowthNote?openid="+this.wechatData.openid)
            .then(res => {
              this.babyData = res.data.data
              console.log(res.data.data)
            })
      }

    },
    toBabyGrow() {
      if (this.wechatData.openid == '') {
        this.onTool()
        return
      }
      window.location.href = "https://apps.doctopia.com.cn/vaccine-map/childrenGraw/pages/index?from=supermum&memberId="+this.wechatData.openid
    },
    toBabyFeed() {
      if (this.wechatData.openid == '') {
        this.onTool()
        return
      }
      window.location.href = "https://apps.doctopia.com.cn/vaccine-map/babyFeed/pages/index/index?from=supermum&memberId="+this.wechatData.openid
    },
    WechatAuthor() {
      const state = Math.random().toString(36).substring(2, 15)
      localStorage.setItem('wx-state', state)
      var url = "https://open.weixin.qq.com/connect/oauth2/authorize?"
      var urlParams = "appid=wx845f93dc631a4c35&redirect_uri=https%3a%2f%2fwxsupermam.yzlysz.com%2fprod-api%2fauthSuperMam%2fcallbackToUserInfo&response_type=code&scope=snsapi_userinfo&state="+state+"#wechat_redirect"
      window.location.href = url + urlParams
      this.visibleConfirm = false
    },
    getLocalStorage(){  // 本地获取用户数据
      var localWechatData = JSON.parse(localStorage.getItem('wechat_user_info'))
      if (localWechatData!=null) {
        this.wechatData = localWechatData
      }
      // var localBabyData = JSON.parse(localStorage.getItem('baby_user_info'))
      // if (localBabyData!=null) {
      //   this.babyData = localBabyData
      // }
    },
    handleUrlParams() {
      const urlParams = new URLSearchParams(window.location.search)

      // 检查是否有微信授权参数
      if (urlParams.has('openid')) {
        const userInfo = {
          openid: decodeURIComponent(urlParams.get('openid')),
          nickname: decodeURIComponent(urlParams.get('nickname')),
          sex: decodeURIComponent(urlParams.get('sex')),
          province: decodeURIComponent(urlParams.get('province')),
          city: decodeURIComponent(urlParams.get('city')),
          country: decodeURIComponent(urlParams.get('country')),
          headimgurl: decodeURIComponent(urlParams.get('headimgurl')),
          privilege: decodeURIComponent(urlParams.get('privilege')),
          unionId: decodeURIComponent(urlParams.get('unionid')),
          authorized: decodeURIComponent(urlParams.get('authorized')),
          state: decodeURIComponent(urlParams.get('state'))
        }
        if (localStorage.getItem('wx-state') != userInfo.state || !userInfo.authorized) {
          // 清除URL参数（可选）
          const cleanUrl = window.location.pathname
          window.history.replaceState({}, document.title, cleanUrl)
          return
        }
        localStorage.removeItem('wx-state')
        this.wechatData = userInfo
        console.log(userInfo)

        // 保存到localStorage
        localStorage.setItem('wechat_user_info', JSON.stringify(userInfo))
        localStorage.setItem('expire_time', JSON.stringify(Date.now() + (24 * 60 * 60 * 1000)))

        // 清除URL参数（可选）
        const cleanUrl = window.location.pathname
        window.history.replaceState({}, document.title, cleanUrl)
      }
    },
    // 初始化微信配置
    initWechatConfig() {
      // 向后端请求微信配置信息
      this.$http.get('prod-api/authSuperMam/getWxJsSDKSignature', {
        params: {
          url: window.location.href.split('#')[0]
        }
      }).then(res => {
        const config = res.data.data
        console.log(config);
        wx.config({
          debug: false, // 生产环境设为false
          appId: config.appId,
          timestamp: config.timestamp,
          nonceStr: config.nonceStr,
          signature: config.signature,
          jsApiList: [
            'updateAppMessageShareData', // 分享给朋友
            'updateTimelineShareData'    // 分享到朋友圈
          ]
        })

        // 配置成功后的回调
        wx.ready(() => {
          this.setShareContent()
        })

        // 配置失败的回调
        wx.error((res) => {
          console.error('微信配置失败', res)
        })
      })
    },

    // 设置分享内容
    setShareContent() {
      const shareData = {
        title: '宝宝成长记录小帮手',
        desc: '对标生长曲线+喂养全记录，速去，新手爸妈不慌～',
        link: 'https://wxsupermam.yzlysz.com',
        imgUrl: 'https://wxsupermam.yzlysz.com/share_icon.png'
      }

      // 配置分享给朋友
      wx.updateAppMessageShareData({
        ...shareData,
        success: () => {
          console.log('分享给朋友配置成功')
        },
        fail: (err) => {
          console.error('分享给朋友配置失败', err)
        }
      })

      // 配置分享到朋友圈
      wx.updateTimelineShareData({
        title: shareData.title,
        link: shareData.link,
        imgUrl: shareData.imgUrl,
        success: () => {
          console.log('分享到朋友圈配置成功')
        },
        fail: (err) => {
          console.error('分享到朋友圈配置失败', err)
        }
      })
    }
  }
}

</script>
<style scoped>
.baby-style {
  width: 20%;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  padding: 15px;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}

.baby-tool-style {
  height: 150px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  margin-top: 20px
}

.baby-tool-info-style {
  background-color: #f5e1fa;
  height: 100%;
  width: 100%;
  padding: 10px;
  border-radius: 20px;
  display: flex;
  justify-content: space-around;
  align-items: center
}
</style>